/* eslint-disable no-mixed-operators */
import _ from 'lodash';
import dagre from 'dagre';
import Action from '../nodes/Action';
import Delay from '../nodes/Delay';
import JourneyStart from '../nodes/JourneyStart';
import Split from '../nodes/Split';
import Exit from '../nodes/Exit';
import JOURNEY_TEMPLATE_KEY_DATA, {
  DEFAULT_EDGES_STYLE,
  DEFAULT_POSITION,
  MARKER_END_ARROW,
} from './constants';

/**
 * to get the predefined mapping between node type and their respective components
 */
export const NODE_TYPES = {
  action: Action,
  wait: Delay,
  split: Split,
  journeyStart: JourneyStart,
  exit: Exit,
};

const METRICS_PADDING = 100;

/**
 * to arrange the position of each nodes automatically by using dagre
 * @param {*} nodes input nodes
 * @param {*} edges input edges
 * @param {*} direction direction
 * @returns
 */
const autoArrange = (nodes, edges, showMetrics = false, direction = 'TB') => {
  const dagreGraph = new dagre.graphlib.Graph();
  dagreGraph.setDefaultEdgeLabel(() => ({}));
  const nodeWidth = 350;
  const nodeHeight = 150;

  const isHorizontal = direction === 'LR';
  dagreGraph.setGraph({ rankdir: direction });

  const extraPadding = showMetrics ? METRICS_PADDING : 0;

  const nodeHeightMapping = {
    journeyStart: 200 + extraPadding,
    action: 160 + extraPadding,
    wait: 130 + extraPadding,
    split: 140 + extraPadding,
    exit: 120 + extraPadding,
  };

  nodes.forEach(node => {
    dagreGraph.setNode(node.id, {
      width: nodeWidth,
      height: nodeHeightMapping[node.type],
    });
  });

  edges.forEach(edge => {
    dagreGraph.setEdge(edge.source, edge.target);
  });

  dagre.layout(dagreGraph);

  nodes.forEach(node => {
    const nodeWithPosition = dagreGraph.node(node.id);
    node.targetPosition = isHorizontal ? 'left' : 'top';
    node.sourcePosition = isHorizontal ? 'right' : 'bottom';

    // We are shifting the dagre node position (anchor=center center) to the top left
    // so it matches the React Flow node anchor point (top left).
    node.position = {
      x: nodeWithPosition.x - nodeWidth / 2,
      y: nodeWithPosition.y - nodeHeight / 2,
    };

    return node;
  });

  return { nodes, edges };
};

/**
 * to convert the backend nodes's data to reactflow formated data.
 * @param {Object} data the backend's nodes data
 */
export const convertToDiagramData = props => {
  // TODO: retrieve from API instead
  let { data } = props;
  const { showMetrics, isView } = props;
  if (!data) {
    data = JOURNEY_TEMPLATE_KEY_DATA[1];
  }

  const nodes = [];
  const edges = [];
  const nodeTypeCount = {};
  _.forEach(data, (node, nodeNumber) => {
    nodeTypeCount[node.type] = +(nodeTypeCount[node.type] || 0) + 1;
    const nodeDetail = {
      id: nodeNumber,
      type: node.type,
      data: {
        ...node.data,
        ...{ nameIndex: nodeTypeCount[node.type], isView, showMetrics },
      },
      position: DEFAULT_POSITION,
      draggable: false,
    };

    if (node.type === 'split') {
      nodeDetail.data.refNode = data[_.get(node, 'data.params.msgNodeID')];
    }

    nodes.push(nodeDetail);

    if (node.children && node.children.length) {
      _.forEach(node.children, (childNumber, idx) => {
        edges.push({
          source: nodeNumber,
          target: childNumber,
          type: DEFAULT_EDGES_STYLE,
          markerEnd: MARKER_END_ARROW,
          label:
            node.type === 'split' ? _.get(node, `data.splits.${idx}`, '') : '',
        });
      });
    }
  });

  return autoArrange(nodes, edges, showMetrics);
};

/**
 * to get whether does not have error or not
 * @param {Object} data node data
 * @param {Array<string>} fields required fields
 * @returns boolean
 */
export const getErrors = (data, fields) => {
  if (!data || !fields) {
    return false;
  }
  return fields.some(key => {
    return !_.get(data, key);
  });
};
